<template>
  <div
    class="tab-pane fade h-100"
    data-view="agenda"
    id="pills-agenda"
    role="tabpanel"
    aria-labelledby="pills-agenda-tab"
  >
    <div class="card full-agenda" v-if="agendaStore.agenda.length > 0">
      <div class="card-body">
        <h4 class="card-title mb-4">{{ $i18n.t('message.Agenda.full_agenda') }}</h4>
        <AgendaCard />
      </div>
    </div>
    <div v-else-if="conferenceStore.error">
      {{ conferenceStore.error }}
    </div>
    <section class="conference-cards" v-if="conferenceStore.conferences.length > 0">
      <ConferenceCard
        v-for="conference in conferenceStore.conferences"
        :conference="conference"
        :key="conference.conference_id"
        :school="school"
      ></ConferenceCard>
    </section>
    <div v-else-if="conferenceStore.loading" class="loading-splash">
      <LoadingIcon />
      <span>Loading</span>
    </div>
    
    <div v-else class="empty-state">
      <figure>
        <IconListEmptyState />
      </figure>
      <div class="title">{{ $i18n.t('message.Agenda.empty_state_title') }}</div>
      <p>{{ $i18n.t('message.Agenda.empty_state_message') }}</p>
    </div>
  </div>

</template>

<script setup>
import ConferenceCard from "@/components/parent/ConferenceCard.vue";
import AgendaCard from "@/components/parent/AgendaCard.vue";
import { useConferenceStore } from "@/stores/parent/conference";
import { useAgendaStore } from "@/stores/parent/agenda";
import LoadingIcon from "@/assets/icons/loading.svg";
import IconListEmptyState from "@/assets/icons/list-empty-state.svg";

const conferenceStore = useConferenceStore();
const agendaStore = useAgendaStore();
defineProps({
  school: Object
});
</script>
